require("../lib/jquery.marquee/jquery.marquee.min.js");
var _ = require("underscore");

google.charts.load('45', {packages: ['corechart']});
google.charts.setOnLoadCallback(function () {
    skipsAndDoubles([12]);
    lossPercent([12]);
    updatePrecision([12]);

    var throttled_updatePrecision = _.throttle(updatePrecision, 300);
    slider.noUiSlider.on('update', throttled_updatePrecision);
    var throttled_skipsAndDoubles = _.throttle(skipsAndDoubles, 100);
    slider.noUiSlider.on('update', throttled_skipsAndDoubles);
    var throttled_numberPlanted = _.throttle(numberPlanted, 100);
    slider.noUiSlider.on('update', throttled_numberPlanted);
    var throttled_lossPercent = _.throttle(lossPercent, 100);
    slider.noUiSlider.on('update', throttled_lossPercent);
});
var noUiSlider = require('nouislider');
var wNumb = require('wnumb');

$(document).ready(function () {

    var slider = document.getElementById('slider');

    noUiSlider.create(slider, {
        start: 12,
        range: {
            'min': 7,
            'max': 17
        },
        tooltips: [wNumb({ decimals: 1 })],
        pips: {
            mode: 'range',
            density: 10
        }
    });

    createPlantDots();
    
    var duration = 10000;
    if ($('.tempoblockmodel').hasClass("half")) {
        duration = 5000;
    }

    var $mq = $('.marquee').marquee({
        duplicated: true,
        duration: duration,
        gap: 0,
        delayBeforeStart: 0,
    });

    $(".noUi-pips").appendTo(".noUi-base");
});

function createPlantDots() {
    
    var containerSize = $('#plantingPrecision').outerWidth();

    var dotSize = $('#comp').outerWidth();

    var numDots = (containerSize / dotSize);

    for (let i = 0; i < numDots; i++) {
        var compdot = "<li id='comp" + i + "'>&bull;</li>";
        var tempodot = "<li id='tempo" + i + "'>&bull;</li>";
        $('#complist').append(compdot);
        $('#tempolist').append(tempodot);
    }
}

function updatePrecision(values) {
    var sliderValue = values[0];

    var dev = ((sliderValue / 2)).toFixed(0);
    var padleft = 6;
    var padright = 6;
    var numberOfDots = $('#complist li').length;

    for (let i = 1; i < numberOfDots; i++) {
        let diff = randomIntFromInterval(0, dev/2);
        diff = (randomIntFromInterval(0, 1) == 0) ? -diff : diff;
        var tempopadleft = 6 + diff;
        var tempopadright = 6 - diff;

        $('#tempo' + i).css('padding-left', tempopadleft);
        $('#tempo' + i).css('padding-right', tempopadright);
    }

    for (let i = 1; i < numberOfDots; i++) {
        let diff = randomIntFromInterval(0, dev);
        diff = (randomIntFromInterval(0, 1) == 0) ? -diff : diff;
        padleft = 6 + diff;
        padright = 6 - diff;

        $('#comp' + i).css('padding-left', padleft);
        $('#comp' + i).css('padding-right', padright);

    }
}

function randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

function skipsAndDoubles(values){
    var sliderValue = values[0];
    var targetTempo = "tempochart";
	var targetComp = "compchart";
    
	var skipsTempo = Math.round(1.2168 * Math.pow(sliderValue, 4) - 56.956 * Math.pow(sliderValue, 3) + 971.04 * Math.pow(sliderValue, 2) - 7119.2 * sliderValue + 19189);

	var skipsComp = Math.round(5.7899 * Math.pow(sliderValue, 3) - 110.17 * Math.pow(sliderValue, 2) + 754.35 * sliderValue - 1397.3);

    drawSkipsChart(skipsTempo, targetTempo);
    drawSkipsChart(skipsComp, targetComp);
    $('#temposkipcount').text(skipsTempo);
    $('#compskipcount').text(skipsComp);
}

function drawSkipsChart(skips, target) {
    var colors = (target == 'tempochart') ? ['a81c22', 'bebebe'] : ['65676c', 'bebebe'];
    var total = 8200;
    var remainder = total - skips;
    
    var data = new google.visualization.DataTable();
    data.addColumn('string', 'skips');
    data.addColumn('number', 'total');
    data.addRows([['skips', skips], ['total', remainder]]);

    var options = {
        'tooltip' : { trigger: 'none' },
        enableInteractivity: false,
        legend: 'none',
        labels: 'none',
        pieHole: 0.75,
        pieSliceText: 'none',
        pieSliceBorderColor: 'transparent',
        backgroundColor:'#ebe7e7',
        colors: colors
    };

    var chart = new google.visualization.PieChart(document.getElementById(target));
    chart.draw(data, options);
}

function lossPercent(values){
    var sliderValue = values[0];
    
    var lossTempo = (0.0016 * Math.pow(sliderValue, 4) - 0.0747 * Math.pow(sliderValue, 3) + 1.2704 * Math.pow(sliderValue, 2) - 9.2811 * sliderValue + 25.281).toFixed(1);
    var lossComp = (0.0044 * Math.pow(sliderValue, 3) - 0.0665 * Math.pow(sliderValue, 2) + 0.2852 * sliderValue + 0.6864).toFixed(1);

    var targetTempo = 'tempoloss';
    var targetComp = 'comploss';
    drawLossChart(lossTempo, targetTempo);
    drawLossChart(lossComp, targetComp);
}

function drawLossChart(loss,  target){
    var colors = (target == 'tempoloss') ? ['a81c22', 'bebebe'] : ['65676c', 'bebebe'];
    var data = google.visualization.arrayToDataTable([
        ['target', 'loss', {role: "style"}],
        ['loss', parseFloat(loss), 'ca0000'],
    ]);

    var view = new google.visualization.DataView(data);
    view.setColumns([0, 1, 
                    {
                        calc: "stringify",
                        sourceColumn: 1,
                        type: "string",
                        role: "annotation"
                    }]);

    var options = {
        enableInteractivity: false, 
        legend: 'none',
        chartArea: {width: "100%"},
        backgroundColor:'#ebe7e7',
        colors: colors,
        fontSize: "16",
        hAxis: {textPosition: 'none', gridlines: {color:'transparent'}, baseline: {color:'transparent'}},
        vAxis: {
            textPosition: 'none', 
            gridlines: {
                color:'transparent'}, 
            baseline: {
                color:'transparent'},
            maxValue: 10,
            minValue: 0
        }
    };

    var chart = new google.visualization.ColumnChart(document.getElementById(target));
    chart.draw(view, options);
}

function numberPlanted(values){
    var numbers = str_pad(Math.round((values[0]*4.57)), 3);
    var splitnumbers = numbers.split("");
    $('#one').text(splitnumbers[0]);
    $('#two').text(splitnumbers[1]);
    $('#three').text(splitnumbers[2]);
}

function str_pad(num, size) {
    var s = "000" + num;
    return s.substr(s.length-size);
}